import * as http from './http';
import ApiService from './service';

export class RoleMenuService extends ApiService {
    async getMenuByRoleId(id) {
        const url = `${this.apiDomain}/api/rolemenuaccess/${id}`;
        try {
            const response = await http.get(url, this.store);
            return response; 
        } catch (err) {
            console.error("API Error:", err);
            return { data: null }; 
        }
    }
}

